import { createReducer, Action, on } from '@ngrx/store';
import { ConnectionStatus, Session } from 'src/app/core/models/session.models';
import { sessionActions } from '../actions';

const initialState: Session = {
    
    loader: false,
    isLogged: null,
    authToken: null,
    isMobile: false,
    blockLogin: false
}


export const appReducer = createReducer(
    initialState,
    
    on(sessionActions.showAppLoader, (state, action) => ({ ...state, loader: true })),//temporary set to false
    on(sessionActions.hideAppLoader, (state, action) => ({ ...state, loader: false })),
    on(sessionActions.sessionLoggedIn, (state, action) => ({ ...state, isLogged: true })),
    on(sessionActions.sessionLoggedOut, (state, action) => ({ ...state, isLogged: false })),
    on(sessionActions.updateAuthToken, (state, action) => ({ ...state, authToken: action.token })),
    on(sessionActions.updateIsMobile, (state, action) => ({ ...state, isMobile: action.status })),
    on(sessionActions.blockLogin, (state, action) => ({ ...state, blockLogin: true })),
    on(sessionActions.unblockLogin, (state, action) => ({ ...state, blockLogin: false })),
);


export function reducer(state: Session | undefined, action: Action) {
    return appReducer(state, action);
}


